// Mirrors backend/src/pdfTemplates/designA/designAFormatters.js's
// paginateDesignARows exactly (same algorithm, same defaults) so the
// on-screen Print Preview breaks pages in the identical place as the
// downloaded PDF. Kept as a separate copy because the backend (Node,
// CommonJS) and this frontend (webpack/babel, ES modules) can't share one
// file directly in this repo -- if the algorithm changes, update both.
export const DEFAULT_ROW_BUDGETS = { single: 16, first: 24, middle: 30, last: 14 };

// rows: array of row objects (shape is the caller's choice; only `rawAmount`
// is read here, for the carried/brought-forward running totals).
// amountFn(rowsSlice) -> formatted running total string for that slice.
export function paginateDesignARows(rows, { rowBudgets = DEFAULT_ROW_BUDGETS, amountFn } = {}) {
  const n = rows.length;
  const sumAmount = (slice) => (amountFn ? amountFn(slice) : 0);

  if (n <= rowBudgets.single) {
    return {
      totalPages: 1,
      pages: [{ type: "single", rows, pageNo: 1, carriedForwardTotal: null, broughtForwardTotal: null }],
    };
  }

  const pages = [];
  let cursor = 0;

  const firstSlice = rows.slice(0, rowBudgets.first);
  cursor = rowBudgets.first;
  pages.push({
    type: "first",
    rows: firstSlice,
    pageNo: 1,
    carriedForwardTotal: sumAmount(rows.slice(0, cursor)),
    broughtForwardTotal: null,
  });

  while (n - cursor > rowBudgets.last) {
    const remaining = n - cursor;
    const take = Math.min(rowBudgets.middle, remaining - rowBudgets.last);
    if (take <= 0) break;
    const slice = rows.slice(cursor, cursor + take);
    const prevCursor = cursor;
    cursor += take;
    pages.push({
      type: "middle",
      rows: slice,
      pageNo: pages.length + 1,
      carriedForwardTotal: sumAmount(rows.slice(0, cursor)),
      broughtForwardTotal: sumAmount(rows.slice(0, prevCursor)),
    });
  }

  const lastSlice = rows.slice(cursor);
  pages.push({
    type: "last",
    rows: lastSlice,
    pageNo: pages.length + 1,
    carriedForwardTotal: null,
    broughtForwardTotal: sumAmount(rows.slice(0, cursor)),
  });

  return { totalPages: pages.length, pages };
}
